const KEY_TOKEN = "kexi.admin.token";
const KEY_USER  = "kexi.admin.user";

export type AdminUser = {
  id: number;
  email: string;
  display_name: string | null;
  role: "admin" | "editor";
};

export function getToken(): string | null {
  return localStorage.getItem(KEY_TOKEN);
}

export function getUser(): AdminUser | null {
  const raw = localStorage.getItem(KEY_USER);
  if (!raw) return null;
  try { return JSON.parse(raw) as AdminUser; } catch { return null; }
}

export function setSession(token: string, user: AdminUser): void {
  localStorage.setItem(KEY_TOKEN, token);
  localStorage.setItem(KEY_USER, JSON.stringify(user));
}

// 只更新缓存的用户信息（如改显示名后），token 不变
export function updateUser(user: AdminUser): void {
  localStorage.setItem(KEY_USER, JSON.stringify(user));
}

export function clearSession(): void {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_USER);
}
